"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importStar(require("react"));
const CommentActivity_1 = __importDefault(require("./fragments/CommentActivity"));
const RecentActivity_1 = __importDefault(require("./fragments/RecentActivity"));
const CompactActivity = ({ actorName, progresses, comment, attachments, dateActivity, involvements, id, isEmpty, isReadOnly }) => {
    const [isCommentOpen, setCommentOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", { className: "bg-n-200 p-[12px] rounded-lg border border-solid border-n-300" },
        react_1.default.createElement(RecentActivity_1.default, { id: id, actorName: actorName, progresses: progresses, comment: comment, attachments: attachments, dateActivity: dateActivity, isCommentOpen: isCommentOpen, setCommentOpen: (state) => !isReadOnly && setCommentOpen(state), isEmpty: isEmpty }),
        isCommentOpen && (react_1.default.createElement(CommentActivity_1.default, { closeComment: () => setCommentOpen(false), id: id, involvements: involvements }))));
};
exports.default = CompactActivity;
